import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MdDialog, MdDialogConfig, MdDialogRef, MdSnackBar} from '@angular/material';
import {ColaboradoresService} from '@services/colaboradores-service';
import {AgrisAccesoRestringidoDialogComponent} from '../../../agris';
import {RemitosSelectorProductosDialogComponent} from './remitos-selector-productos-dialog';
import {AgrisService} from '@services/agris-service';
import * as moment from 'moment';
import {ChoferViewModel, RemitosService} from '@services/remitos-service';
import {CuentasService} from '@services/cuentas-service';
import {SpinnerService} from '@services/spinner-service';
import {ProvinciasService} from '@services/provincias-service';
import {Router} from '@angular/router';
import {SEARCH_TYPE_CUENTA, SearchService} from '@services/search-service';
import {Observable} from 'rxjs/Observable';
import {FormSelectItem, FormSelectSingleComponent, FormSelectSingleIsComponent} from '@common/form-components';
import {of} from 'rxjs/observable/of';
import {Subscription} from 'rxjs/Subscription';
import {RemitosMotivoDialog} from '../common';

@Component({
  selector: 'app-remitos-generar-page',
  templateUrl: './remitos-generar-page.component.html',
  styleUrls: [
    './remitos-generar-page.component.scss',
    '../common/remitos-common-styles.scss',
  ],
})
export class RemitosGenerarPageComponent implements OnInit, AfterViewInit {
  form: FormGroup = null;
  jdeAllowed = false;

  public username = '';

  public fechaHoy = moment().format('DD/MM/YYYY');
  public nombreSucursal: string = 'Sucursal';
  public nombreOficina: string = 'Oficina';
  public motivo: string = '';
  errorBasic = 'Por favor, complete este campo';
  subscriptionTsunami = new Subscription();

  @ViewChild('clienteSearchComp') clienteComp: FormSelectSingleIsComponent;
  clientesOptions: FormSelectItem[] = [];
  clientesLoading = false;

  sucursalComercialCtrl = new FormControl('', [Validators.required]);
  oficinaComercialCtrl = new FormControl('', [Validators.required]);
  centroEmisorCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  unidadDeNegocioCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  numLegalRemitoCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  numeroComprobanteCtrl = new FormControl('', [Validators.required]);
  clienteCtrl = new FormControl('', [Validators.required]);
  provinciaClienteCtrl = new FormControl('', [Validators.required]);
  codPostalOrigenCtrl = new FormControl('', [Validators.required]);
  provinciaOrigenCtrl = new FormControl('', [Validators.required]);
  codPostalDestinoCtrl = new FormControl('', [Validators.required]);
  provinciaDestinoCtrl = new FormControl('', [Validators.required]);
  direccionEntregaCtrl = new FormControl('', [Validators.required]);
  cuitTransportistaCtrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('^([0-9]{11}|[0-9]{2}-[0-9]{8}-[0-9]{1})$'))]);
  idTransportistaCtrl = new FormControl({ value: '-', disabled: true }, [Validators.required]);
  nombreTransportistaCtrl = new FormControl({ value: '-', disabled: true }, []);
  cuitChoferCtrl = new FormControl('', [Validators.required, Validators.pattern(new RegExp('^([0-9]{11}|[0-9]{2}-[0-9]{8}-[0-9]{1})$'))]);
  idChoferCtrl = new FormControl({ value: '-', disabled: true }, [Validators.required]);
  nombreChoferCtrl = new FormControl({ value: '-', disabled: true }, []);
  vehiculoCtrl = new FormControl('', [Validators.required]);
  acopladoCtrl = new FormControl('', [Validators.required]);
  productosCtrl = new FormControl('', [Validators.required]);
  observacionesCtrl = new FormControl('');
  caiCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  caiDesdeCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);
  caiHastaCtrl = new FormControl({ value: '', disabled: true }, [Validators.required]);

  constructor(
    private fb: FormBuilder,
    private dialog: MdDialog,
    private colaboradoresService: ColaboradoresService,
    private agrisService: AgrisService,
    private remitosService: RemitosService,
    private cuentasService: CuentasService,
    private spinnerService: SpinnerService,
    private snackbar: MdSnackBar,
    public provinciasService: ProvinciasService,
    private router: Router,
    private searchService: SearchService,
  ) {

    if (!this.remitosService.motivoGeneracion) {
      this.router.navigateByUrl('/administracion/remitos');
    }

    this.getMotivo();

    this.form = fb.group({
      sucursalComercial: this.sucursalComercialCtrl,
      oficinaComercial: this.oficinaComercialCtrl,
      centroEmisor: this.centroEmisorCtrl,
      unidadDeNegocio: this.unidadDeNegocioCtrl,
      numLegalRemito: this.numLegalRemitoCtrl,
      numeroComprobante: this.numeroComprobanteCtrl,
      cliente: this.clienteCtrl,
      provinciaCliente: this.provinciaClienteCtrl,
      codPostalOrigen: this.codPostalOrigenCtrl,
      provinciaOrigen: this.provinciaOrigenCtrl,
      codPostalDestino: this.codPostalDestinoCtrl,
      provinciaDestino: this.provinciaDestinoCtrl,
      direccionEntrega: this.direccionEntregaCtrl,
      cuitTransportista: this.cuitTransportistaCtrl,
      idTransportista: this.idTransportistaCtrl,
      nombreTransportista: this.nombreTransportistaCtrl,
      cuitChofer: this.cuitChoferCtrl,
      idChofer: this.idChoferCtrl,
      nombreChofer: this.nombreChoferCtrl,
      vehiculo: this.vehiculoCtrl,
      acoplado: this.acopladoCtrl,
      productos: this.productosCtrl,
      observaciones: this.observacionesCtrl,
      cai: this.caiCtrl,
      caiDesde: this.caiDesdeCtrl,
      caiHasta: this.caiHastaCtrl,
      motivo: [{ value: this.motivo, disabled: true }, []],
    });

    // Para los campos deshabilitados hay que configurar la validación a nivel de formulario
    this.form.setValidators([
      (form) => Validators.required(form.get('unidadDeNegocio')),
      (form) => Validators.required(form.get('centroEmisor')),
      (form) => Validators.required(form.get('cai')),
      (form) => Validators.required(form.get('caiDesde')),
      (form) => Validators.required(form.get('caiHasta')),
    ]);

    this.colaboradoresService.getUserJDEAccess().take(1).subscribe((x) => {
      if (x !== null && x !== undefined) {
        this.jdeAllowed = x.length > 0;
      }
    });

    this.colaboradoresService.getColaborador(Number(localStorage.getItem('userId'))).take(1).subscribe((user) => {
      this.username = user.UserFullName;
    });

    agrisService.initializeOficinaSucursal();

    // Rastrear cambios en CUIT transportista para validar contra el BE
    const traSub = this.cuitTransportistaCtrl.valueChanges.switchMap(cuitTransportista => {
      this.idTransportistaCtrl.reset('-');
      this.nombreTransportistaCtrl.reset('-');

      if (this.cuitTransportistaCtrl.errors !== null) {
        const err = this.cuitTransportistaCtrl.errors;
        delete err.notFound;
        this.cuitTransportistaCtrl.setErrors(err);
      }
      if (!this.cuitTransportistaCtrl.valid) {
        return of(null);
      } else {
        this.cuitTransportistaCtrl.markAsTouched();
        return this.cuentasService.getClienteByCuit(cuitTransportista);
      }
    }).subscribe(clientes => {
      if (clientes && clientes.length > 0) {
        const transportista = clientes[0];
        this.idTransportistaCtrl.setValue(transportista.AN8);
        this.nombreTransportistaCtrl.setValue(transportista.Nombre);
        this.cuitTransportistaCtrl.setErrors(null);
      } else {
        this.cuitTransportistaCtrl.setErrors({
          ...this.cuitTransportistaCtrl.errors,
          notFound:
            'El CUIT no corresponde a un transportista registrado',
        });
      }
    });
    this.subscriptionTsunami.add(traSub);

    // Rastrear cambios en CUIT de chofer para validar contra el BE
    const choferSub = this.cuitChoferCtrl.valueChanges.switchMap(cuitChofer => {
      this.idChoferCtrl.reset('-');
      this.nombreChoferCtrl.reset('-');
      if (this.cuitChoferCtrl.errors !== null) {
        const err = this.cuitChoferCtrl.errors;
        delete err.notFound;
        this.cuitChoferCtrl.setErrors(err);
      }
      if (!this.cuitChoferCtrl.valid) {
        return of(null);
      } else {
        this.cuitChoferCtrl.markAsTouched();
        return this.remitosService.getChoferByCuit(cuitChofer)
      }
    }).subscribe((choferes: ChoferViewModel[]) => {
      if (choferes && choferes.length > 0) {
        const chofer = choferes[0];
        this.idChoferCtrl.setValue(chofer.ChoferID);
        this.nombreChoferCtrl.setValue(chofer.Nombre);
      } else {
        this.cuitChoferCtrl.setErrors({
          ...this.cuitChoferCtrl.errors,
          notFound: 'El CUIT no corresponde a un chofer registrado',
        });
      }
    });
    this.subscriptionTsunami.add(choferSub);

    // info de CAI

    // Información de CAI

    const ceEmisorSub = this.centroEmisorCtrl.valueChanges.switchMap((idCentroEmisor) => {
      return idCentroEmisor && idCentroEmisor.length ? this.remitosService.getNumeroCAI(idCentroEmisor) : of(null)
    }).subscribe(data => {
        if (data) {
          this.caiCtrl.setValue(data.NumeroCAI);
          this.caiDesdeCtrl.setValue(moment(data.FechaDesde, 'YYYY-MM-DD').format('DD/MM/YYYY'));
          this.caiHastaCtrl.setValue(moment(data.FechaHasta, 'YYYY-MM-DD').format('DD/MM/YYYY'));
        }
      },() => {
        this.caiCtrl.setErrors({noData: true});
        this.caiDesdeCtrl.setErrors({noData: true});
        this.caiHastaCtrl.setErrors({noData: true});
        this.showCriticalInfoError();
      }
    );
    this.subscriptionTsunami.add(ceEmisorSub);
  }

  ngOnInit() {
    // Información de Agris
    let centroEmisorBackup = '';
    this.colaboradoresService.getUserJDEAccess().switchMap(data => {
      if (data.length) {
        let userAgris = data[0];
        this.oficinaComercialCtrl.setValue(userAgris.Oficina_Comercial);
        this.sucursalComercialCtrl.setValue(userAgris.Sucursal_Comercial);
        // Obtener nombre de oficina/sucursal
        return this.remitosService.getOficina(userAgris.Oficina_Comercial.Id);
      } else {
        return of(null);
      }
    }).switchMap(oficina => {
        if (oficina) {
          this.nombreOficina = oficina.Nombre;
          this.nombreSucursal = oficina.Nombre;

          // a partir de la info de la oficina, obtenemos estos valores
          this.centroEmisorCtrl.setValue('');
          this.unidadDeNegocioCtrl.setValue('');
          this.numLegalRemitoCtrl.setValue('');
          this.numLegalRemitoCtrl.setValue('');
          return this.remitosService.getCentrosEmisores(oficina.Id);
        } else {
          return of(null);
        }
      }
    ).switchMap(centrosEmisores => {
        if (centrosEmisores && centrosEmisores.length > 0) {
          let centroEmisorValue =
            centrosEmisores[0].CentroEmisorId;
          this.centroEmisorCtrl.setValue(centroEmisorValue);
          this.unidadDeNegocioCtrl.setValue(
            centrosEmisores[0].UnidadDeNegocio
          );
          centroEmisorBackup = centroEmisorValue;
          return this.remitosService.getNextNumeroRemito(centroEmisorValue);
        } else {
          return of(null);
        }
      }
    ).take(1).subscribe(
      (res) => {
        if (res) {
          this.numeroComprobanteCtrl.setValue(res.Numero);
          let number = res.Numero.toString();
          // simulamos un padstart dado que no existe en esta version de typescript
          while (number.length < 8) {
            number = `0${number}`
          }
          this.numLegalRemitoCtrl.setValue(centroEmisorBackup.toString() + number);
        } else {
          this.showCriticalInfoError();
        }
      },
      () => this.showCriticalInfoError()
    );
  }

  ngAfterViewInit() {
    const cliSub = this.clienteComp.$searchValue.debounceTime(500).switchMap(res => {
      this.clientesLoading = true;
      // aqui realizamos la busqueda
      const searchVal = res.trim();
      if (searchVal.length >= 3) {
        return this.searchService.searchAutocomplete(searchVal, SEARCH_TYPE_CUENTA);
      } else {
        // si no hay mas de 3 caracteres, eliminamos la busqueda
        this.clientesOptions = [];
        return Observable.from([[]]);
      }
    }).map( value => {
      value.forEach(emp => {
        if (emp.CuentaAcopio) {
          emp.cuentasAcopios = '';
          emp.CuentaAcopio.forEach(e => {
            if (e.CuentaAcopio !== 0) {
              emp.cuentasAcopios += e.CuentaAcopio.toString() + ', ';
            }
          });
          if (emp.cuentasAcopios.length) {
            emp.cuentasAcopios = emp.cuentasAcopios.slice(0, -2);
          }
        }
      });
      return value;
    }).subscribe(res => {
      // finalmente nos suscribimos al resultado de la busqueda
      this.clientesOptions = res && res.length ? res.map(x => ({Label: x.FullName, Id: x.An8, RawValue: JSON.stringify(x)})) : [];
      this.clientesLoading = false;
    });
    this.subscriptionTsunami.add(cliSub);
  }

  getMotivo() {
    if (this.remitosService.motivoGeneracion) {
      this.motivo = this.remitosService.motivoGeneracion;
    }
  }

  generarRemito() {
    // marcamos todos los controles como tocados para mostrar los errores de validacion en caso que
    // no se haya completado algun campo
    Object.keys(this.form.controls)
      .map((x) => this.form.controls[x])
      .forEach((x) => {
        x.markAsTouched();
      });

    if (this.form.invalid) {
      return;
    }
    this.enviarRemito();
  }

  enviarRemito() {
    // Recuperamos todos los campos incluyendo los deshabilitados
    const remitoForm = this.form.getRawValue();

    // Agregamos el arreglo de insumos
    this.spinnerService.setShowFlag(true);
    this.remitosService.postRemito(remitoForm).take(1).subscribe(
      () => {
        this.snackbar.open('Remito generado correctamente.', null, {
          duration: 3000,
        });
        this.spinnerService.setShowFlag(false);
        this.remitosService.motivoGeneracion = '';
        this.router.navigateByUrl('/administracion/remitos');
      },
      () => {
        this.snackbar.open(
          'Se ha producido un error al procesar la solicitud.',
          null,
          { duration: 3000 }
        );
        this.spinnerService.setShowFlag(false);
      }
    );
  }

  openSelectorProductosDialog() {
    // el selector de productos, realiza una busqueda de productos de agris. por lo que debemos
    // realizar la misma comprobacion de user en JDE que en agris. en caso ded no poseer mostramos el mismo
    // cartel y no permitimos completar el campo (en consecuencia no podrá generar el remito)
    if (!this.jdeAllowed) {
      let config = new MdDialogConfig();
      config.panelClass = 'dialog-pannel-custom';
      config.width = '343px';
      this.dialog.open(AgrisAccesoRestringidoDialogComponent, config);
      return;
    }

    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    const dialogRef = this.dialog.open(
      RemitosSelectorProductosDialogComponent,
      config
    );
    if (this.productosCtrl.valid) {
      dialogRef.componentInstance.loadOldProductos(this.productosCtrl.value);
    }
    dialogRef.afterClosed().take(1).subscribe((res) => {
      this.productosCtrl.markAsTouched();
      // verificamos que haya alguna respuesta desde el dialog
      if (!!res) {
        this.productosCtrl.setValue(res);
      }
    });
  }

  getProductoLabel() {
    if (!this.productosCtrl.value) {
      return 'Seleccionar productos';
    } else {
      const trail = this.productosCtrl.value.length > 1 ? 's' : '';
      return `${this.productosCtrl.value.length} Producto${trail} seleccionado${trail}`;
    }
  }

  showCriticalInfoError() {
    this.snackbar.open(
      'Ha ocurrido un error al obtener información necesaria para la generacion del remito.',
      null,
      { duration: 3000 }
    );
  }

  getTransportistaErrorMessage() {
    if (!this.cuitTransportistaCtrl.errors || !this.cuitTransportistaCtrl.invalid || !this.cuitTransportistaCtrl.touched) {
      return ''
    }
    if (this.cuitTransportistaCtrl.errors.required) {
      return this.errorBasic;
    }
    if (this.cuitTransportistaCtrl.errors.pattern) {
      return 'Por favor, ingrese un CUIT válido';
    }
    if (this.cuitTransportistaCtrl.errors.notFound) {
      return this.cuitTransportistaCtrl.errors.notFound;
    }
  }

  getChoferErrorMessage() {
    if (!this.cuitChoferCtrl.errors || !this.cuitChoferCtrl.invalid || !this.cuitChoferCtrl.touched) {
      return ''
    }
    if (this.cuitChoferCtrl.errors.required) {
      return this.errorBasic;
    }
    if (this.cuitChoferCtrl.errors.pattern) {
      return 'Por favor, ingrese un CUIT válido';
    }
    if (this.cuitChoferCtrl.errors.notFound) {
      return this.cuitChoferCtrl.errors.notFound;
    }
  }

}

interface NroCai {
  CentroEmisor: string;
  FechaDesde: string;
  FechaHasta: string;
  KCO: string;
  NumeroCAI: string;
  TipoDGI: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-generar-page/remitos-generar-page.component.ts